import type { SearchAvailableParams } from "./types";

export const phoneNumberKeys = {
  all: ["PHONE_NUMBERS"] as const,
  lists: () => [...phoneNumberKeys.all, "LIST"] as const,
  searchAvailable: (params: SearchAvailableParams) =>
    [...phoneNumberKeys.all, "SEARCH_AVAILABLE", params] as const,
  propertyDefaults: () =>
    [...phoneNumberKeys.all, "PROPERTY_DEFAULTS"] as const,
  propertyDefault: (propertyId: number) =>
    [...phoneNumberKeys.all, "PROPERTY_DEFAULT", propertyId] as const,
  leasingAgents: () => ["LEASING_AGENTS"] as const
};
